module.exports = __webpack_public_path__ + "static/media/currWeek2.1d5eebd4.svg";